import {styled} from '@mui/material'
import PropTypes from 'prop-types'

export const StyledDiv = styled('div')(() => ({
  justifyContent: 'center',
  display: 'flex',
  padding: '3%'
}))

const GivePrismLogo = ({logoPath, defaultHeight = '70px'}) => {
  return (
    <StyledDiv>
      <img
        height={defaultHeight}
        src={logoPath}
        alt="GivePrism Logo"
        style={{
          display: 'block',
          maxWidth: '100%'
        }}
      />
    </StyledDiv>
  )
}

GivePrismLogo.propTypes = {
  logoPath: PropTypes.string,
  defaultHeight: PropTypes.string
}

export default GivePrismLogo
